import AccountDownloadsConfigurator from './AccountDownloadsConfigurator';

export default AccountDownloadsConfigurator;
